import React from 'react';
import scrollToComponent from 'react-scroll-to-component';

import '../components/Gallery/GallerySite.scss';

import siteBanner_img from '../assets/img/llc/sectionTopBanner.jpg';
import { GalleryMenu, GalleryContent } from "../components";

const options = {
  align: "top",
  scrollDuration: 300, //500 ms
  offset: -60 //Header + 10px
};

class Gallery extends React.Component {
  constructor() {
    super();

    this.state = {
      activeSurgery: 1,
      activeProcedure: 1
    }
  }

  setRef = (input) => {
    //this.categoriesRef = input;
  };

  changeContent = (surgery, procedure) => {
    scrollToComponent(this.refs.categoriesRef, options);
    this.setState({
      activeSurgery: surgery,
      activeProcedure: procedure
    })
  };

    surgeryChanged = (id) => {
        scrollToComponent(this.refs.categoriesRef, options);
        this.setState({
            activeSurgery: id,
            activeProcedure: 0
        })
    };

  render() {
    const langs = this.props.texts.langs;

    const surgery = langs.surgery.find(sur => sur.id === this.state.activeSurgery);

    return (
      <div>
        <div className="siteBanner newBg">
          <img src={siteBanner_img} className="siteBanner_bg"/>
          <h2 className="line">Galerie</h2>
        </div>
        <div className="galleryWrapper" ref="categoriesRef">
          <GalleryMenu
            langs={{
              surgery: langs.surgery
            }}
            activeProcedure={this.state.activeProcedure}
            changeContent={this.changeContent}
            surgeryChanged={this.surgeryChanged}
          />
          <GalleryContent
            surgery={surgery}
            activeProcedure={this.state.activeProcedure}
            setRef={this.setRef}
          />
        </div>
      </div>
    );
  }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/containers/Gallery.js